import {
  DEFAULT_LANGUAGE,
  SupportedLanguage,
  TranslatableField,
} from '@/models/TranslatableField';

export const getTranslatableValue = (
  field?: TranslatableField,
  lang: SupportedLanguage = DEFAULT_LANGUAGE,
): string => {
  if (!field) return '';
  if (typeof field === 'string') return field;
  return field[lang] || field['pt-br'] || field['en'];
};
